import React, { Fragment, MouseEventHandler, useEffect, useMemo, useState } from 'react';
import classes from '../../forms/Checkbox/Checkbox.module.scss';
import { idGenerator } from '../../../helpers/idGenerator';
import classNames from 'classnames';
import inputClasses from '../../forms/form.module.scss';
import { CheckboxViewProps } from '../../forms/Checkbox/Checkbox.view';

export type CheckboxWithActionViewProps = {
  name: CheckboxViewProps['name'];
  size: CheckboxViewProps['size'];
  id?: string;
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  value?: string;
  onClickHandler: MouseEventHandler<HTMLInputElement>;
  wrapper?: boolean;
};

export const CheckboxWithActionView = (props: CheckboxWithActionViewProps): JSX.Element => {
  const inputID = useMemo(() => props.id ?? idGenerator(props.name), [props.id, props.name]);
  const globalClasses = classNames(inputClasses.FormInputs, inputClasses[props.size]);
  const checkboxWrapperClasses = classNames(classes.CheckboxWrapper, classes[`CheckboxSize_${props.size}`], {
    'input-wrapper': props.wrapper
  });

  // props.checked does not trigger rerender. It is internal to input element and in dom, if we want to make sure that
  // dot element actually shows checked property, since we need it for css styling, we need to make sure that we
  // rerender the component
  const [_, setRerender] = useState({});
  useEffect(() => {
    setRerender({});
  }, [props.checked]);

  const label = (
    <label htmlFor={inputID} className={classes.Opaque}>
      {!!props.label ? props.label : <span className={'show-for-sr'}>{props.name}</span>}
    </label>
  );

  const elem = (
    <input
      id={inputID}
      type={'checkbox'}
      checked={!!props.checked}
      className={globalClasses}
      disabled={props.disabled}
      readOnly={props.readonly}
      onClick={props.onClickHandler}
      onChange={() => {
        // ... require to prevent becoming read-only
      }}
      {...(props.value ? { value: props.value } : {})}
    />
  );

  const elemWrapper = (
    <div className={checkboxWrapperClasses}>
      {elem}
      {label}
    </div>
  );

  return <Fragment>{elemWrapper}</Fragment>;
};
